import { render, staticRenderFns } from "./StatusItem.vue?vue&type=template&id=53202882&scoped=true"
import script from "./StatusItem.vue?vue&type=script&lang=js"
export * from "./StatusItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53202882",
  null
  
)

export default component.exports